module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-card-3"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.showBullets) ? _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns n1 align-self-middle"
  }, [_vm._t("n1")], 2), _c('div', {
    staticClass: "columns n2 align-self-middle"
  }, [_vm._t("n2")], 2), _c('div', {
    staticClass: "columns n3 align-self-middle"
  }, [_vm._t("n3")], 2)])]), (_vm.showAction) ? _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_vm._t("actionPage")], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c178c1dc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/Card3.vue
// module id = 2686
// module chunks = 1